<template>
  <div class="page-safeGrade">
    <div class="page-contentSafe">
      <a-layout>
        <div class="page-SafeHder">
          <a-layout-header>
            <div class="page-tabSafe">
              <a-tabs :activeKey="tabKey" @change="callbackBasic">
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.General_Information')"
                  key="1"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.Security_Level')"
                  key="2"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.UserCenter.Company_Profile')"
                  key="3"
                ></a-tab-pane>
              </a-tabs>
            </div>
          </a-layout-header>
        </div>
        <div class="page-coSafe">
          <a-layout-content>
            <div class="page-safe-form">
              <div class="page-safe-left">
                <span class="page-sfe-span">
                  {{ $tc('lang.UserCenter.Your_Security_Level') }}
                </span>
                <a-progress
                  type="circle"
                  :percent="userInfoMap.marginOfSafety"
                  :width="200"
                />
              </div>
              <div class="page-safe-right">
                <div>
                  <a-icon
                    v-if="
                      userInfoMap.personPassword === null ||
                        userInfoMap.personPassword === ''
                    "
                    type="close-circle"
                    style="color: crimson"
                  />
                  <a-icon
                    v-if="
                      userInfoMap.personPassword !== null &&
                        userInfoMap.personPassword !== '' &&
                        userInfoMap.personPassword !== undefined
                    "
                    type="check-circle"
                    style="color: chartreuse"
                    theme="filled"
                  />
                  <span class="span1">{{
                    $tc('lang.UserCenter.Log_in_password')
                  }}</span>
                  <!-- <span>等级中</span> -->
                  <span class="span2">{{
                    $tc('lang.UserCenter.Get_your_password_more_secure')
                  }}</span>
                  <a-button
                    type="primary"
                    html-type="submit"
                    size="small"
                    @click="
                      () => {
                        this.visibleLogin = true;
                      }
                    "
                  >
                    {{ $tc('lang.UserCenter.update') }}
                  </a-button>
                </div>
                <div>
                  <a-icon
                    v-if="
                      userInfoMap.personPaypassword === null ||
                        userInfoMap.personPaypassword === ''
                    "
                    type="close-circle"
                    style="color: crimson"
                  />
                  <a-icon
                    v-if="
                      userInfoMap.personPaypassword !== null &&
                        userInfoMap.personPaypassword !== '' &&
                        userInfoMap.personPaypassword !== undefined
                    "
                    type="check-circle"
                    style="color: chartreuse"
                    theme="filled"
                  />
                  <span class="span1">{{
                    $tc('lang.UserCenter.pay_password')
                  }}</span>
                  <span class="span2">{{
                    $tc('lang.UserCenter.Get_your_password_more_secure')
                  }}</span>
                  <a-button
                    type="primary"
                    html-type="submit"
                    size="small"
                    @click="
                      () => {
                        this.visible = true;
                      }
                    "
                  >
                    {{ $tc('lang.UserCenter.Settings') }}
                  </a-button>
                </div>
                <div>
                  <a-icon
                    type="check-circle"
                    style="color: chartreuse"
                    theme="filled"
                  />
                  <span class="span1">{{
                    $tc('lang.UserCenter.Mobile_Number')
                  }}</span>
                  <!-- <span>已设置</span> -->
                  <span class="span2"
                    >{{ $tc('lang.UserCenter.Verify_your_mobile_number') }}:{{
                      userInfoMap.personMobilephone
                    }}</span
                  >
                  <a-button
                    type="primary"
                    html-type="submit"
                    size="small"
                    @click="
                      () => {
                        this.visibleTow = true;
                      }
                    "
                  >
                    {{ $tc('lang.UserCenter.Verify') }}
                  </a-button>
                </div>
                <div
                  v-if="
                    userInfoMap.personEmail === null ||
                      userInfoMap.personEmail === ''
                  "
                >
                  <a-icon type="close-circle" style="color: crimson" />
                  <span class="span1">{{ $tc('lang.UserCenter.E_mail') }}</span>
                  <!-- <span>未设置</span> -->
                  <span class="span2">{{
                    $tc('lang.UserCenter.Unverified_Email')
                  }}</span>
                  <a-button
                    type="primary"
                    html-type="submit"
                    size="small"
                    @click="
                      () => {
                        this.visibleEmail = true;
                      }
                    "
                  >
                    {{ $tc('lang.UserCenter.Immediate_binding') }}
                  </a-button>
                </div>
                <div
                  v-if="
                    userInfoMap.personEmail !== null &&
                      userInfoMap.personEmail !== '' &&
                      userInfoMap.personEmail !== undefined
                  "
                >
                  <a-icon
                    type="check-circle"
                    style="color: chartreuse"
                    theme="filled"
                  />
                  <span class="span1">{{ $tc('lang.UserCenter.E_mail') }}</span>
                  <span class="span2">{{
                    $tc('lang.UserCenter.Rebind_mailbox')
                  }}</span>
                  <a-button
                    type="primary"
                    html-type="submit"
                    size="small"
                    @click="
                      () => {
                        this.visibleEmail = true;
                      }
                    "
                  >
                    {{ $tc('lang.UserCenter.Immediate_binding') }}
                  </a-button>
                </div>
                <div>
                  <a-icon type="close-circle" style="color: crimson" />
                  <span class="span1">{{
                    $tc('lang.UserCenter.Company_Profile_t')
                  }}</span>
                  <!-- <span>未完善</span> -->
                  <span class="span2">{{
                    $tc('lang.UserCenter.Improve_account_level')
                  }}</span>
                  <a-button
                    type="primary"
                    html-type="submit"
                    size="small"
                    @click="
                      () => {
                        this.$router.push('/enterprise');
                      }
                    "
                  >
                    {{ $tc('lang.UserCenter.update') }}
                  </a-button>
                </div>
              </div>
            </div>
          </a-layout-content>
        </div>
      </a-layout>
      <!-- 修改支付密码 -->
      <a-modal
        :title="$tc('lang.UserCenter.Modify_Payment_Password')"
        :width="400"
        v-model="visible"
        :destroyOnClose="true"
        @ok="handleOk"
      >
        <a-form
          :form="form"
          @submit="handleSubmitPay"
          style="width: 70%;margin: 0 auto"
        >
          <a-form-item>
            <a-input
              v-if="
                userInfoMap.personPaypassword !== null ||
                  userInfoMap.personPaypassword !== ''
              "
              :placeholder="
                $tc('lang.UserCenter.Please_enter_the_original_password')
              "
              type="password"
              v-decorator="[
                'originalPassword',
                // {
                //   rules: [
                //     {
                //       required: true,
                //       message: '请输入6位数字的支付密码',
                //     },
                //   ],
                // },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
            <span style="color: #b6b6b6;">{{
              $tc('lang.UserCenter.If_payment_password')
            }}</span>
          </a-form-item>
          <a-form-item>
            <a-input
              :placeholder="$tc('lang.UserCenter.Check_New_password')"
              type="password"
              v-decorator="[
                'passOne',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.UserCenter.please_payment_password'),
                    },
                    { validator: $checking.validatePayPassword },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              :placeholder="$tc('lang.UserCenter.Check_password_tow')"
              type="password"
              v-decorator="[
                'passTow',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.UserCenter.Check_password_tow'),
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
        </a-form>
        <template slot="footer">
          <a-button
            key="back"
            @click="
              () => {
                this.visible = false;
              }
            "
            >{{ $tc('lang.UserCenter.Clear') }}</a-button
          >
          <a-button key="submit" type="primary" @click="handleSubmitPay">
            {{ $tc('lang.UserCenter.confirm_update') }}
          </a-button>
        </template>
      </a-modal>
      <!-- 修改登录密码 -->
      <a-modal
        :title="$tc('lang.UserCenter.Modify_login_password')"
        :width="400"
        v-model="visibleLogin"
        :destroyOnClose="true"
        @ok="handleOkLogin"
      >
        <a-form
          :form="formLogin"
          @submit="handleSubmitLogin"
          style="width: 70%;margin: 0 auto"
        >
          <a-form-item>
            <a-input
              v-if="
                userInfoMap.personPassword !== null ||
                  userInfoMap.personPassword !== ''
              "
              :placeholder="
                $tc('lang.UserCenter.Please_enter_the_original_password')
              "
              type="password"
              v-decorator="[
                'originalPassword',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.UserCenter.Check_text'),
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              :placeholder="$tc('lang.UserCenter.Check_New_password')"
              type="password"
              v-decorator="[
                'passOne',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.UserCenter.Check_text'),
                    },
                    { validator: $checking.validatePassword },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              :placeholder="$tc('lang.UserCenter.Check_New_password')"
              type="password"
              v-decorator="[
                'passTow',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.UserCenter.Check_New_password'),
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
        </a-form>
        <template slot="footer">
          <a-button
            key="back"
            @click="
              () => {
                this.visibleLogin = false;
              }
            "
            >{{ $tc('lang.UserCenter.Clear') }}</a-button
          >
          <a-button key="submit" type="primary" @click="handleSubmitLogin">
            {{ $tc('lang.UserCenter.confirm_update') }}
          </a-button>
        </template>
      </a-modal>
      <!-- 手机号验证 -->
      <a-modal
        :title="$tc('lang.UserCenter.Mobile_phone_number_verification')"
        :width="400"
        v-model="visibleTow"
        :destroyOnClose="true"
        @ok="handleOkTow"
      >
        <a-form
          :form="form"
          @submit="handleSubmitTow"
          style="width: 70%;margin: 0 auto"
        >
          <a-form-item>
            <a-input
              :placeholder="$tc('lang.UserCenter.Immediate_binding')"
              v-decorator="[
                'numMobile',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.UserCenter.Please_phone_number'),
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input-group compact>
              <a-input
                style="width: 65%"
                :placeholder="
                  $tc('lang.UserCenter.Please_enter_the_verification_code')
                "
                v-decorator="[
                  'numBBMobile',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc(
                          'lang.UserCenter.Please_enter_the_verification_code',
                        ),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color:rgba(0,0,0,.25)"
                />
              </a-input>
              <a-button
                style="font-size: 12px;width: 35%"
                :disabled="
                  code == $tc('lang.UserCenter.Get_the_authentication_code')
                    ? false
                    : true
                "
                @click="getCodeMobile"
                >{{ code }}</a-button
              >
            </a-input-group>
          </a-form-item>
        </a-form>
        <template slot="footer">
          <a-button
            key="back"
            @click="
              () => {
                this.visibleTow = false;
              }
            "
            >{{ $tc('lang.UserCenter.Clear') }}</a-button
          >
          <a-button key="submit" type="primary" @click="handleSubmitTow">
            {{ $tc('lang.UserCenter.Immediate_binding') }}
          </a-button>
        </template>
      </a-modal>
      <!-- 邮箱验证 -->
      <a-modal
        :title="$tc('lang.UserCenter.Mailbox_Verification')"
        :width="400"
        v-model="visibleEmail"
        :destroyOnClose="true"
        @ok="handleOkEmail"
      >
        <a-form
          :form="formEmail"
          @submit="handleSubmitEmail"
          style="width: 70%;margin: 0 auto"
        >
          <a-form-item>
            <a-input
              :placeholder="
                $tc('lang.UserCenter.Please_enter_your_mailbox_address')
              "
              v-decorator="[
                'personEmail',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc(
                        'lang.UserCenter.Please_enter_your_mailbox_address',
                      ),
                    },
                  ],
                },
              ]"
            >
              <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input-group compact>
              <a-input
                style="width: 65%"
                :placeholder="
                  $tc('lang.UserCenter.Please_enter_the_verification_code')
                "
                v-decorator="[
                  'numberEm',
                  {
                    rules: [
                      {
                        required: true,
                        message: $tc(
                          'lang.UserCenter.Please_enter_the_verification_code',
                        ),
                      },
                    ],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color:rgba(0,0,0,.25)"
                />
              </a-input>
              <a-button
                style="font-size: 12px;width: 35%"
                :disabled="
                  code == $tc('lang.UserCenter.Get_the_authentication_code')
                    ? false
                    : true
                "
                @click="getCode"
                >{{ code }}</a-button
              >
            </a-input-group>
          </a-form-item>
        </a-form>
        <template slot="footer">
          <a-button
            key="back"
            @click="
              () => {
                this.visibleEmail = false;
              }
            "
            >{{ $tc('lang.UserCenter.Clear') }}</a-button
          >
          <a-button key="submit" type="primary" @click="handleSubmitEmail">
            {{ $tc('lang.UserCenter.Immediate_binding') }}
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: 'safeGrade',
  data() {
    return {
      tabKey: '2',
      formLayout: 'horizontal',
      // 修改支付密码弹框
      visible: false,
      form: this.$form.createForm(this),
      // 登录密码
      visibleLogin: false,
      formLogin: this.$form.createForm(this),
      // 验证码弹框
      visibleTow: false,
      form1: this.$form.createForm(this),
      // 获取验证码
      code: '获取验证码',
      // 邮箱验证
      visibleEmail: false,
      formEmail: this.$form.createForm(this),
    };
  },
  // 数据状态处理全局
  computed: {
    userInfoMap: {
      get() {
        return this.$store.state.user.userInfoMap;
      },
      set(value) {
        this.$store.commit('user/save', {
          userInfoMap: value,
        });
      },
    },
    loginUpdate: {
      get() {
        return this.$store.state.user.loginUpdate;
      },
      set(value) {
        this.$store.commit('user/save', {
          loginUpdate: value,
        });
      },
    },
    //邮箱验证码
    emaliNum: {
      get() {
        return this.$store.state.user.emaliNum;
      },
      set(value) {
        this.$store.commit('user/save', {
          emaliNum: value,
        });
      },
    },
    // 手机号验证码
    mobildNum: {
      get() {
        return this.$store.state.user.mobildNum;
      },
      set(value) {
        this.$store.commit('user/save', {
          mobildNum: value,
        });
      },
    },
  },
  created() {
    this.$store.dispatch('user/userBasicData');
  },
  methods: {
    /*基本信息,安全等级,企业资料:路由切换跳转路径*/
    callbackBasic(key) {
      console.log(key);
      if (key === '1') {
        this.$router.push('/basic');
      }
      if (key === '2') {
        this.$router.push('/safeGrade');
      }
      if (key === '3') {
        this.$router.push('/enterprise');
      }
    },
    // 手机验证
    handleOkTow(e) {
      console.log(e);
      this.visibleTow = false;
    },
    // 手机验证码校验
    handleSubmitTow(e) {
      e.preventDefault();
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const mobildNum = this.mobildNum.toString();
          console.log('9304', mobildNum);
          if (mobildNum === values.numBBMobile) {
            this.$store.dispatch('user/updatePersonMassage', values);
            this.visibleTow = false;
          } else {
            this.$message.error('验证码不一致，请重新输入！');
          }
        }
      });
    },
    // 修改支付密码
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    // 修改登录密码
    handleOkLogin(e) {
      console.log(e);
      this.visibleLogin = false;
    },
    // 修改登录密码校验
    handleSubmitLogin(e) {
      e.preventDefault();
      this.formLogin.validateFields((err, values) => {
        if (!err) {
          if (values !== {}) {
            if (values.passOne !== values.passTow) {
              this.$message.error('两个密码不一致，请重新设置！！！');
              this.formLogin.resetFields();
            } else {
              const data = {
                originalPassword: values.originalPassword,
                passOne: values.passOne,
                passTow: values.passTow,
                type: 9,
              };
              this.$store.dispatch('user/passwordLoginUpdate', data);
              this.visibleLogin = false;
            }
          }
        }
      });
    },
    // 邮箱验证
    handleOkEmail(e) {
      console.log(e);
      this.visible = false;
    },
    handleSubmitEmail(e) {
      e.preventDefault();
      this.formEmail.validateFields((err, values) => {
        if (!err) {
          const emaliNu = this.emaliNum.toString();
          if (emaliNu === values.numberEm) {
            this.$store.dispatch('user/updatePersonMassage', values);
            this.visibleEmail = false;
          } else {
            this.$message.error('验证码不一致，请重新输入！');
          }
        }
      });
    },
    // 获取邮箱验证码时间
    getCode() {
      const emailData = this.formEmail.getFieldValue('personEmail');
      if (emailData !== undefined) {
        let time = 60;
        this.code = `${time}s`;
        let _this = this;
        let setTime = setInterval(function() {
          time--;
          _this.code = `${time}s`;
          if (time == 0) {
            _this.code = '获取验证码';
            clearInterval(setTime);
          }
        }, 1000);
        this.$store.dispatch('user/sendMail', emailData);
      } else {
        this.$message.error('请输入邮箱地址');
      }
    },
    // 获取手机号验证码时间
    getCodeMobile() {
      const numMobile = this.form.getFieldValue('numMobile');
      if (numMobile !== undefined) {
        let time = 60;
        this.code = `${time}s`;
        let _this = this;
        let setTime = setInterval(function() {
          time--;
          _this.code = `${time}s`;
          if (time == 0) {
            _this.code = '获取验证码';
            clearInterval(setTime);
          }
        }, 1000);
        this.$store.dispatch('user/sendMessage', numMobile);
      } else {
        this.$message.error('请输入手机号码');
      }
    },
    // 邮箱
    handleSubmit(e) {
      console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const emaliNu = this.emaliNum.toString();
          if (emaliNu === values.number) {
            this.$store.dispatch('user/updatePersonMassage', values);
            this.visible = false;
          } else {
            this.$message.error('验证码不一致，请重新输入！');
          }
        }
      });
    },
    // 支付密码修改校验
    handleSubmitPay(e) {
      console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values !== {}) {
            if (values.passOne !== values.passTow) {
              this.$message.error('两个密码不一致，请重新设置！！！');
              this.form.resetFields();
            } else {
              const data = {
                originalPassword: values.originalPassword,
                passOne: values.passOne,
                passTow: values.passTow,
                type: 10,
              };
              this.$store.dispatch('user/passwordLoginUpdate', data);
              this.visible = false;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="less">
.page-safeGrade {
  .page-contentSafe {
    border-left: 1px solid #f0f2f5;
    border-right: 1px solid #f0f2f5;
    border-bottom: 1px solid #f0f2f5;
    border-radius: 10px;
    margin-top: 3%;
    .ant-layout {
      height: calc(100vh - 209px);
      background-color: #fff;
    }
    .page-SafeHder {
      .ant-layout-header {
        padding: 0 25px;
        background-color: #fff;
        height: 44px;
      }
    }
    .page-tabSafe {
      .ant-tabs-nav .ant-tabs-tab-active {
        background-color: #e9eef3;
      }
      .ant-tabs-nav {
        float: left;
      }
    }
    .page-coSafe {
      // overflow-y: auto;
      background-color: #ffffff;
      width: 89%;
      .page-safe-form {
        display: flex;
        align-items: center;
        height: calc(100vh - 269px);
        .page-safe-left {
          padding: 0 120px;
          .page-sfe-span {
            font-size: 25px;
            padding-bottom: 20px;
            // padding-top: 60%;
            display: block;
          }
        }
        .page-safe-right {
          text-align: left;
          margin-top: 40px;
          > div {
            margin-bottom: 12px;
            width: 110%;
            i {
              margin-right: 20px;
            }
            .span1 {
              display: inline-block;
              width: 120px;
            }
            .span2 {
              display: inline-block;
              width: 230px;
            }
          }
        }
      }
    }
  }
}
</style>
